module.exports = __webpack_public_path__ + "static/img/fish100.f7fa19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish100.png
// module id = d+n2
// module chunks = 0